/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'twitter': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="currentColor" d="M16 3.54c-.59.26-1.22.43-1.88.51a3.33 3.33 0 001.44-1.81c-.64.37-1.34.65-2.09.79a3.29 3.29 0 00-5.68 2.25c0 .26.03.51.09.75A9.359 9.359 0 011.11 2.6a3.28 3.28 0 00-.44 1.65c0 1.14.76 2.14 1.64 2.73C1.77 6.96 1 6.81 1 6.57v.04c0 1.59.95 2.92 2.45 3.22-.27.07-.65.11-.95.11a3.6 3.6 0 01-.66-.06c.42 1.31 1.61 2.26 3.04 2.29-1.12.87-2.55 1.4-4.09 1.4-.26 0-.53-.01-.79-.05C1.46 14.46 3.18 15 5.03 15c6.04 0 9.34-5 9.34-9.34l-.01-.43c.64-.46 1.2-1.04 1.64-1.69 0 0-.44.65 0 0z"/>'
  }
})
